module.exports = {
    "id": null,
    "name": "",
    "hashtags": null
};